import { render, staticRenderFns } from "./AddResolution.vue?vue&type=template&id=f1f20f48"
import script from "./AddResolution.vue?vue&type=script&lang=js"
export * from "./AddResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports